export interface IActivite {
    type?: string | null;
    num?: string | null;
    objectifs?: string | null;
    imput_budget?: number | null;
    montant_estim?: number | null;
    cout_prev?: number | null;
    montant_dec?: number | null;
    prev_dec?: number | null;
    horizon?: string | null;
    coup_prev?: number | null;
    poids?: number | null;
    struc_res?: string | null;
    struc_asso?: string | null;
    superv?: string | null;
    mode_exec?: string | null;
    observation?: string | null;
    prev_dec_27?: number | null;
    produit?: number | null;
    date_debut?: Date | null;
    date_fin?: Date | null;

}


export const defaultActivite: IActivite = {
    type: "PROGRAMME",
    num: "P1",
    objectifs: "",
    imput_budget: 0,
    montant_estim: 0,
    cout_prev: 0,
    montant_dec: 0,
    prev_dec: 0,
    horizon: "",
    coup_prev: 0,
    poids: 0,
    struc_res: "",
    struc_asso: "",
    superv: "",
    mode_exec: "",
    observation: "",
    prev_dec_27: 0,
    produit: 0,
    date_debut: null,
    date_fin: null,
};

export function 
createActivite(data?: Partial<IActivite>): IActivite {
    return { ...defaultActivite, ...data };
}

